import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-csnotes',
  templateUrl: './csnotes.component.html',
  styleUrls: ['./csnotes.component.css']
})
export class CsnotesComponent implements OnInit {

  data = [
    { Computer_Science: 'chapter 1' , PDF: 'Download', link: '../../assets/pdf/csch1.pdf'},
    { Computer_Science: 'chapter 2' , PDF: 'Download', link: '../../assets/pdf/csch2.pdf'},
    { Computer_Science: 'chapter 3' , PDF: 'Download', link: '../../assets/pdf/csch3.pdf'},
    { Computer_Science: 'chapter 4' , PDF: 'Download', link: '../../assets/pdf/csch4.pdf'},
    { Computer_Science: 'chapter 5' , PDF: 'Download', link: '../../assets/pdf/csch5.pdf'},
    { Computer_Science: 'chapter 6' , PDF: 'Download', link: '../../assets/pdf/csch6.pdf'}
  ];
  headers =  [
    {key: 'Computer_Science' , label : 'Computer_Science'},
    {key: 'PDF' , label : 'PDF'},
   
    
  ]
  items = [
    { ICT: 'chapter 1' , PDF: 'Download', link: '../../assets/pdf/ictch1.pdf'},
    { ICT: 'chapter 2' , PDF: 'Download', link: '../../assets/pdf/ictch2.pdf'},
    { ICT: 'chapter 3' , PDF: 'Download', link: '../../assets/pdf/ictch3.pdf'},
    { ICT: 'chapter 4' , PDF: 'Download', link: '../../assets/pdf/ictch4.pdf'},
    { ICT: 'chapter 5' , PDF: 'Download', link: '../../assets/pdf/ictch5.pdf'},
    { ICT: 'chapter 6' , PDF: 'Download', link: '../../assets/pdf/ictch6.pdf'}
  ];
  headers2 =  [
    {key: 'ICT' , label : 'ICT'},
    {key: 'PDF' , label : 'PDF'},
     
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
